"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ContactHero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.3
  });
  return <section id="contact-hero" className="relative min-h-[70vh] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-br from-[hsl(220,30%,8%)] via-[hsl(215,25%,18%)] to-[hsl(210,20%,25%)] bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1524742/img/contact_hero_abstract_gradient.png)] bg-cover bg-center" style={{
      transform: isVisible ? "scale(1.05)" : "scale(1)",
      transition: "transform 0.6s ease-out"
    }} />

      {}
      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center transition-all duration-[150ms] ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        <h1 className="text-5xl sm:text-6xl lg:text-7xl font-display font-bold text-foreground mb-6" style={{
        textShadow: "0 0 20px hsla(178, 80%, 50%, 0.3), 0 0 40px hsla(178, 80%, 50%, 0.15)"
      }}>
          Contact Us
        </h1>
        <p className="text-xl sm:text-2xl text-muted-foreground max-w-2xl mx-auto" style={{
        textShadow: "0 0 15px hsla(0, 0%, 95%, 0.2)"
      }}>And let's create something extraordinary together</p>
      </div>
    </section>;
}